export default __webpack_public_path__ + "static/Necto-Mono-a81f4ca2f551f030a1d057ce12ba5c21.woff";